const ActionTypes = {
  RESET_STATE: "RESET_STATE",
  SET_COURSE_LIST: "SET_COURSE_LIST",
  SET_ACTIVE_COURSE: "SET_ACTIVE_COURSE",
  SET_COURSE_LANGUAGES: "SET_COURSE_LANGUAGES",
  SET_COURSE_DETAILS: "SET_COURSE_DETAILS",
  SET_SCHEDULED_NOTIFICATIONS_LIST: "SET_SCHEDULED_NOTIFICATIONS_LIST",
  EMPTY_LAST_EVALUATED_KEY_LIST: "EMPTY_LAST_EVALUATED_KEY_LIST",
  SET_ACTIVE_FILTERS_DRIVER_NOTIFICATION:
    "SET_ACTIVE_FILTERS_DRIVER_NOTIFICATION",
  REMOVE_LAST_EVALUATED_KEY_FROM_LIST: "REMOVE_LAST_EVALUATED_KEY_FROM_LIST",
  SET_LAST_EVALUATED_KEY_CAMPAIGN: "SET_LAST_EVALUATED_KEY_CAMPAIGN",
  SET_ACTIVE_CAMPAIGN: "SET_ACTIVE_CAMPAIGN",
  SET_NEW_CAMPAIGN_OPTIONS: "SET_NEW_CAMPAIGN_OPTIONS",
  SET_UPLOADED_FILE_NAME: "SET_UPLOADED_FILE_NAME",
  SET_ACTIVE_FILE_PATH: "SET_ACTIVE_FILE_PATH",
  SET_UPLOADED_IMAGE_NAME: "SET_UPLOADED_IMAGE_NAME",
  SET_ACTIVE_CSV_HEADERS: "SET_ACTIVE_CSV_HEADERS",
  SET_FEATURE_LIST: "SET_FEATURE_LIST",
  SET_ACTIVE_FEATURE: "SET_ACTIVE_FEATURE",
  SET_CURRENT_PAGE_FEATURE: "SET_CURRENT_PAGE_FEATURE",
  SET_CURRENT_PAGE_FEATURE_TOGGLE: "SET_CURRENT_PAGE_FEATURE_TOGGLE",
  SET_ACTIVE_FILTERS: "SET_ACTIVE_FILTERS",
  RESET_STATE_FEATURE: "RESET_STATE_FEATURE",
  SET_FEATURE_TOGGLE_LIST: "SET_FEATURE_TOGGLE_LIST",
  SET_ACTIVE_FEATURE_TOGGLE: "SET_ACTIVE_FEATURE_TOGGLE",
  SET_ACTIVE_FILTERS_TOGGLE: "SET_ACTIVE_FILTERS_TOGGLE",
  RESET_STATE_FEATURE_TOGGLE: "RESET_STATE_FEATURE_TOGGLE",
  SET_COUNTRY_LIST: "SET_COUNTRY_LIST",
  SET_CURRENT_PAGE_COUNTRY: "SET_CURRENT_PAGE_COUNTRY",
  SET_ACTIVE_COUNTRY: "SET_ACTIVE_COUNTRY",
  RESET_STATE_COUNTRY: "RESET_STATE_COUNTRY",
  DELETE_COUNTRY: "DELETE_COUNTRY",
  SET_STATE_LIST: "SET_STATE_LIST",
  SET_CITY_LIST: "SET_CITY_LIST",
  SET_CURRENT_PAGE_CITY: "SET_CURRENT_PAGE_CITY",
  SET_ACTIVE_CITY_FILTERS: "SET_ACTIVE_CITY_FILTERS",
  RESET_STATE_CITY: "RESET_STATE_CITY",
  SET_ACTIVE_CITY: "SET_ACTIVE_CITY",
  SET_LOCALITY_LIST: "SET_LOCALITY_LIST",
  SET_CURRENT_PAGE_LOCALITY: "SET_CURRENT_PAGE_LOCALITY",
  SET_ACTIVE_LOCALITY_FILTERS: "SET_ACTIVE_LOCALITY_FILTERS",
  RESET_STATE_LOCALITY: "RESET_STATE_LOCALITY",
  SET_ACTIVE_LOCALITY: "SET_ACTIVE_LOCALITY",
  SET_ACTIVE_POLYGON: "SET_ACTIVE_POLYGON",
  SET_POLYGON_LIST: "SET_POLYGON_LIST",
  SET_POLYGON_TYPES: "SET_POLYGON_TYPES",
  SET_CURRENT_PAGE_POLYGON: "SET_CURRENT_PAGE_POLYGON",
  SET_ACTIVE_POLYGON_FILTERS: "SET_ACTIVE_POLYGON_FILTERS",
  RESET_STATE_POLYGON: "RESET_STATE_POLYGON",
  SET_ERROR: "SET_ERROR",
  SET_LOADER: "SET_LOADER",
  SET_ACTIVE_STATE: "SET_ACTIVE_STATE",
  SET_ACTIVE_STATE_FILTERS: "SET_ACTIVE_STATE_FILTERS",
  RESET_STATE_STATE: "RESET_STATE_STATE",
  SET_CURRENT_PAGE_STATE: "SET_CURRENT_PAGE_STATE",
  SET_TRAINING_STATUS_LIST: "SET_TRAINING_STATUS_LIST",
  RESET_TRAINING_STATUS: "RESET_TRAINING_STATUS",
  SET_MENUS: "SET_MENUS",
  SET_MENU_ACTIONS: "SET_MENU_ACTIONS",
  SET_FAILED_TO_FETCH_MENU: "SET_FAILED_TO_FETCH_MENU",
  SET_DRIVER_TAGS_LIST: "SET_DRIVER_TAGS_LIST",
  SET_CURRENT_PAGE_DRIVER_TAGS: "SET_CURRENT_PAGE_DRIVER_TAGS",
  RESET_STATE_DRIVER_TAGS: "RESET_STATE_DRIVER_TAGS",
  SET_ACTIVE_DRIVER_TAG: "SET_ACTIVE_DRIVER_TAG",
  SET_ACTIVE_FILTERS_DRIVER_TAGS: "SET_ACTIVE_FILTERS_DRIVER_TAGS",
  SET_ACTIVE_QUERY_PARAMS: "SET_ACTIVE_QUERY_PARAMS",
  SET_DRIVER_TAGS_MAPPING_LIST: "SET_DRIVER_TAGS_MAPPING_LIST",
  SET_ACTIVE_FILTERS_DRIVER_TAGS_MAPPINGS:
    "SET_ACTIVE_FILTERS_DRIVER_TAGS_MAPPINGS",
  SET_CURRENT_PAGE_DRIVER_TAGS_MAPPINGS:
    "SET_CURRENT_PAGE_DRIVER_TAGS_MAPPINGS",
  SET_CITY_PROPERTY_LIST: "SET_CITY_PROPERTY_LIST",
  SET_ACTIVE_CITY_PROPERTY: "SET_ACTIVE_CITY_PROPERTY",
  RESET_STATE_CITY_PROPERTY: "RESET_STATE_CITY_PROPERTY",
  SET_GEN_SETTING_LIST: "SET_GEN_SETTING_LIST",
  SET_ACTIVE_GEN_SETTING: "SET_ACTIVE_GEN_SETTING",
  RESET_STATE_GEN_SETTING: "RESET_STATE_GEN_SETTING",
  GET_GEN_SETTING_RULES: "GET_GEN_SETTING_RULES",
  SET_ACTIVE_LEVEL: "SET_ACTIVE_LEVEL",
  RESET_STATE_LEVEL: "RESET_STATE_LEVEL",
  SET_LEVEL: "SET_LEVEL",
  SET_FINAL_CONFIG: "SET_FINAL_CONFIG",
  SET_ORDER: "SET_ORDER",
  SET_ACTIVE_RULE: "SET_ACTIVE_RULE",
  SET_FORM_SCHEMA: "SET_FORM_SCHEMA",
  SET_DRIVER_ACCOUNTING_SETTLEMENT_PROCESSES:
    "SET_DRIVER_ACCOUNTING_SETTLEMENT_PROCESSES",
  SET_ACTIVE_DRIVER_ACCOUNTING_SETTLEMENT_PROCESSES_FILTERS:
    "SET_ACTIVE_DRIVER_ACCOUNTING_SETTLEMENT_PROCESSES_FILTERS",
  RESET_STATE_DRIVER_ACCOUNTING_SETTLEMENT_PROCESSES:
    "RESET_STATE_DRIVER_ACCOUNTING_SETTLEMENT_PROCESSES",
  SET_CURRENT_PAGE_DRIVER_ACCOUNTING_SETTLEMENT_PROCESS:
    "SET_CURRENT_PAGE_DRIVER_ACCOUNTING_SETTLEMENT_PROCESS",
  SET_DRIVER_ASSETS_ISSUED_LIST: "SET_DRIVER_ASSETS_ISSUED_LIST",
  RESET_STATE_DRIVER_ASSETS: "RESET_STATE_DRIVER_ASSETS",
  RESET_STATE_DRIVER_MEDALS: "RESET_STATE_DRIVER_MEDALS",
  RESET_STATES_DRIVER_ASSETS: "RESET_STATES_DRIVER_ASSETS",
  SET_ACTIVE_FILTERS_DRIVER_ASSETS: "SET_ACTIVE_FILTERS_DRIVER_ASSETS",
  SET_DRIVER_CITIES: "SET_DRIVER_CITIES",
  SET_DRIVER_ASSETS_AVAILABLE_LIST: "SET_DRIVER_ASSETS_AVAILABLE_LIST",
  SET_DRIVER_MEDALS_DETAILS: "SET_DRIVER_MEDALS_DETAILS",
  SET_DRIVER_METRIC_LIST: "SET_DRIVER_METRIC_LIST",
  SET_RECENT_ASSET_STATUS: "SET_RECENT_ASSET_STATUS",
  SET_ONBOARDING_CENTERS: "SET_ONBOARDING_CENTERS",
  SET_PAYMENT_FLOW: "SET_PAYMENT_FLOW",
  SET_ROLES_LIST: "SET_ROLES_LIST",
  SET_ACTIVE_ROLE: "SET_ACTIVE_ROLE",
  RESET_STATE_ROLES: "RESET_STATE_ROLES",
  SET_ACTIVE_FILTERS_ROLES: "SET_ACTIVE_FILTERS_ROLES",
  SET_ACTIONS_LIST: "SET_ACTIONS_LIST",
  SET_TELECALLER_PROFILES: "SET_TELECALLER_PROFILES",
  SET_ACTIVE_TELECALLER: "SET_ACTIVE_TELECALLER",
  SET_CLUSTERS_TELECALLER: "SET_CLUSTERS_TELECALLER",
  SET_ACTIVE_FILTERS_TELECALLER: "SET_ACTIVE_FILTERS_TELECALLER",
  RESET_STATE_TELECALLER: "RESET_STATE_TELECALLER",
  SET_CURRENT_PAGE_TELECALLERS: "SET_CURRENT_PAGE_TELECALLERS",
  SET_TELECALLER_LEADS: "SET_TELECALLER_LEADS",
  SET_ACTIVE_LEAD_ENGAGEMENT: "SET_ACTIVE_LEAD_ENGAGEMENT",
  SET_CURRENT_PAGE_TELECALLERS_LEADS: "SET_CURRENT_PAGE_TELECALLERS_LEADS",
  RESET_STATE_TELECALLER_LEADS: "RESET_STATE_TELECALLER_LEADS",
  SET_DRIVER_CASH_TRANSACTIONS_LIST: "SET_DRIVER_CASH_TRANSACTIONS_LIST",
  SET_ACTIVE_FILTERS_DRIVER_CASH_TRANSACTIONS:
    "SET_ACTIVE_FILTERS_DRIVER_CASH_TRANSACTIONS",
  SET_CURRENT_PAGE_DRIVER_CASH_TRANSACTIONS:
    "SET_CURRENT_PAGE_DRIVER_CASH_TRANSACTIONS",
  RESET_STATE_DRIVER_CASH_TRANSACTIONS: "RESET_STATE_DRIVER_CASH_TRANSACTIONS",
  SET_TRIP_STATISTICS_DATA: "SET_TRIP_STATISTICS_DATA",
  RESET_STATE_TRIP_STATISTICS: "RESET_STATE_TRIP_STATISTICS",
  TELECALLER_LEADS_SET_REASONS: "TELECALLER_LEADS_SET_REASONS",
  ASSETS_ISSUANCE_SET_DRIVER_DETAILS: "ASSETS_ISSUANCE_SET_DRIVER_DETAILS",
  ASSETS_ISSUANCE_SET_ISSUING_ASSETS: "ASSETS_ISSUANCE_SET_ISSUING_ASSETS",
  ASSETS_ISSUANCE_SET_PARTNER_DETAILS: "ASSETS_ISSUANCE_SET_PARTNER_DETAILS",
  ASSETS_ISSUANCE_RESET_DRIVER_DETAILS: "ASSETS_ISSUANCE_RESET_DRIVER_DETAILS",
  ASSETS_ISSUANCE_RESET_PARTNER_DETAILS:
    "ASSETS_ISSUANCE_RESET_PARTNER_DETAILS",
  ASSETS_ISSUANCE_RESET_ISSUING_ASSETS: "ASSETS_ISSUANCE_RESET_ISSUING_ASSETS",
  SET_TDS_AND_RIDER_PAYOUT_JOBS_LIST: "SET_TDS_AND_RIDER_PAYOUT_JOBS_LIST",
  RESET_TDS_AND_RIDER_PAYOUT_JOBS: "RESET_TDS_AND_RIDER_PAYOUT_JOBS",
  SET_ACTIVE_FILTERS_SHIFTS_GROUP: "SET_ACTIVE_FILTERS_SHIFTS_GROUP",
  SET_SHIFTS_GROUP_LIST: "SET_SHIFTS_GROUP_LIST",
  RESET_STATE_SHIFTS_GROUP: "RESET_STATE_SHIFTS_GROUP",
  SET_ACTIVE_SHIFTS_GROUP: "SET_ACTIVE_SHIFTS_GROUP",
  SET_ACTIVE_FILTERS_SHIFTS: "SET_ACTIVE_FILTERS_SHIFTS",
  SET_SHIFTS_LIST: "SET_SHIFTS_LIST",
  RESET_STATE_SHIFTS: "RESET_STATE_SHIFTS",
  SET_ACTIVE_SHIFT: "SET_ACTIVE_SHIFT",
  SET_CURRENT_PAGE_SHIFTS: "SET_CURRENT_PAGE_SHIFTS",
  SET_ACTIVE_FILTERS_AUDIT_HISTORY: "SET_ACTIVE_FILTERS_AUDIT_HISTORY",
  SET_AUDIT_HISTORY_LIST: "SET_AUDIT_HISTORY_LIST",
  SET_DRIVERS_COUNT: "SET_DRIVERS_COUNT",
  SET_DRIVER_BASIC_DETAILS: "SET_DRIVER_BASIC_DETAILS",
  SET_DRIVER_ADDITIONAL_DETAILS: "SET_DRIVER_ADDITIONAL_DETAILS",
  SET_DRIVER_ASSET_DETAILS: "SET_DRIVER_ASSET_DETAILS",
  SET_DRIVER_RESERVATION_DETAILS: "SET_DRIVER_RESERVATION_DETAILS",
  SET_DRIVER_STORE_MAPPING_DETAILS: "SET_DRIVER_STORE_MAPPING_DETAILS",
  SET_ELIGIBLE_DRIVER_SERVICES: "SET_ELIGIBLE_DRIVER_SERVICES",
  SET_DRIVERS_LIST: "SET_DRIVERS_LIST",
  SET_DRIVER_ASSIGNMENT_STATUS: "SET_DRIVER_ASSIGNMENT_STATUS",
  SET_DRIVER_SERVICES_DETAILS: "SET_DRIVER_SERVICES_DETAILS",
  SET_DRIVER_MIGRATION_DETAILS: "SET_DRIVER_MIGRATION_DETAILS",
  RESET_STATE_DELIVERY_DRIVERS: "RESET_STATE_DELIVERY_DRIVERS",
  SET_DRIVER_LOCALITIES_DETAILS: "SET_DRIVER_LOCALITIES_DETAILS",
  SET_DRIVER_FINANCIAL_DETAILS: "SET_DRIVER_FINANCIAL_DETAILS",
  SET_DRIVER_LOGS_DETAILS: "SET_DRIVER_LOGS_DETAILS",
  SET_DRIVER_DELIVERY_STATUSES: "SET_DRIVER_DELIVERY_STATUSES",
  SET_DRIVER_DELIVERY_SERVICES: "SET_DRIVER_DELIVERY_SERVICES",
  SET_DRIVER_LIFECYCLE_STATUSES: "SET_DRIVER_LIFECYCLE_STATUSES",
  SET_CARRIERS_LIST: "SET_CARRIERS_LIST",
  RESET_INDIVIDUAL_DRIVER_STATE: "RESET_INDIVIDUAL_DRIVER_STATE",
  SET_DRIVER_PROFESSIONS: "SET_DRIVER_PROFESSIONS",
  SET_DRIVER_EDUCATIONS: "SET_DRIVER_EDUCATIONS",
  SET_DRIVER_EDUCATION_QUALIFICATIONS: "SET_DRIVER_EDUCATION_QUALIFICATIONS",
  SET_CARRIER_MODELS: "SET_CARRIER_MODELS",
  SET_ACTIVE_FILTER_TELECALLER_LEADS: "SET_ACTIVE_FILTER_TELECALLER_LEADS",
  SET_CITY_PROPERTY_CHANGE_LOG: "SET_CITY_PROPERTY_CHANGE_LOG",
  SET_GEN_SETTING_CHANGE_LOG: "SET_GEN_SETTING_CHANGE_LOG",
  RESET_STATE_CHANGE_LOG: "RESET_STATE_CHANGE_LOG",
  SET_ACTIVE_FILTERS_CHANGE_LOG: "SET_ACTIVE_FILTERS_CHANGE_LOG",
  SET_PROPERTY_KEYS: "SET_PROPERTY_KEYS",
  SET_DRIVER_BANK_STATUS: "SET_DRIVER_BANK_STATUS",
  SET_DRIVER_ACTION_REASONS: "SET_DRIVER_ACTION_REASONS",
  SET_DRIVER_DOCUMENTS: "SET_DRIVER_DOCUMENTS",
  SET_GROOMING_SELFIES_LIST: "SET_GROOMING_SELFIES_LIST",
  SET_ACTIVE_FILTERS_GROOMING_SELFIES: "SET_ACTIVE_FILTERS_GROOMING_SELFIES",
  RESET_STATE_GROOMING_SELFIES: "RESET_STATE_GROOMING_SELFIES",
  SET_INVENTORIES_LIST: "SET_INVENTORIES_LIST",
  SET_ACTIVE_FILTERS_INVENTORIES: "SET_ACTIVE_FILTERS_INVENTORIES",
  RESET_STATE_INVENTORIES: "RESET_STATE_INVENTORIES",
  SET_GIGS_SUPPORT_LIST: "SET_GIGS_SUPPORT_LIST",
  SET_ACTIVE_FILTERS_GIGS_SUPPORT: "SET_ACTIVE_FILTERS_GIGS_SUPPORT",
  SET_SLOT_HISTORY_DETAIL: "SET_SLOT_HISTORY_DETAIL",
  RESET_STATE_GIGS_SUPPORT: "RESET_STATE_GIGS_SUPPORT",
  SET_RIDER_PAYOUTS: "SET_RIDER_PAYOUTS",
  SET_ACTIVE_FILTERS_RIDER_PAYOUTS: "SET_ACTIVE_FILTERS_RIDER_PAYOUTS",
  RESET_STATE_DRIVER_SUPPORT: "RESET_STATE_DRIVER_SUPPORT",
  SET_DRIVER_ASSET_ISSUANCE_TRACKING_DATA:
    "SET_DRIVER_ASSET_ISSUANCE_TRACKING_DATA",
  RESET_STATE_DRIVER_ASSET_ISSUANCE_TRACKING_DATA:
    "RESET_STATE_DRIVER_ASSET_ISSUANCE_TRACKING_DATA",
  SET_ACTIVE_FILTERS_DELIVERY_DRIVERS: "SET_ACTIVE_FILTERS_DELIVERY_DRIVERS",
  SET_ACTIVE_FILTERS_BOUNDARIES: "SET_ACTIVE_FILTERS_BOUNDARIES",
  RESET_BOUNDARIES_STATE: "RESET_BOUNDARIES_STATE",
  SET_GEO_BOUNDARIES: "SET_GEO_BOUNDARIES",
  SET_ZONE_LIST: "SET_ZONE_LIST",
  SET_CURRENT_PAGE_ZONE: "SET_CURRENT_PAGE_ZONE",
  SET_ACTIVE_ZONE_FILTERS: "SET_ACTIVE_ZONE_FILTERS",
  RESET_STATE_ZONE: "RESET_STATE_ZONE",
  SET_ACTIVE_ZONE: "SET_ACTIVE_ZONE",
  SET_SLOTS_LIST: "SET_SLOTS_LIST",
  SET_ACTIVE_SLOT: "SET_ACTIVE_SLOT",
  SET_ACTIVE_FILTERS_SLOTS: "SET_ACTIVE_FILTERS_SLOTS",
  RESET_STATE_SLOT: "RESET_STATE_SLOT",
  RESET_STATE_QC: "RESET_STATE_QC",
  SET_QC_DETAILS: "SET_QC_DETAILS",
  SET_QC_ADDITIONAL_DATA: "SET_QC_ADDITIONAL_DATA",
  SET_CURRENT_FEID: "SET_CURRENT_FEID",
  SET_ACTIVE_FILTERS_MERCHANT_FACADE: "SET_ACTIVE_FILTERS_MERCHANT_FACADE",
  SET_MERCHANT_FACADE_PIC_LIST: "SET_MERCHANT_FACADE_PIC_LIST",
  SET_CURRENT_PAGE_MERCHANT_FACADE: "SET_CURRENT_PAGE_MERCHANT_FACADE",
  RESET_STATE_MERCHANT_FACADE: "RESET_STATE_MERCHANT_FACADE",
  SET_APP_RELEASES_LIST: "SET_APP_RELEASES_LIST",
  SET_ACTIVE_APP_RELEASE: "SET_ACTIVE_APP_RELEASE",
  SET_ACTIVE_APP_RELEASES_FILTERS: "SET_ACTIVE_APP_RELEASES_FILTERS",
  RESET_STATE_DRIVER_APP_RELEASES: "RESET_STATE_DRIVER_APP_RELEASES",
  SET_CURRENT_PAGE_APP_RELEASES: "SET_CURRENT_PAGE_APP_RELEASES",
  SET_CHAT_DEPARTMENTS: "SET_CHAT_DEPARTMENTS",
  SET_CURRENT_PAGE_CHAT_DEPARTMENTS: "SET_CURRENT_PAGE_CHAT_DEPARTMENTS",
  SET_ACTIVE_CHAT_DEPARTMENT_FILTERS: "SET_ACTIVE_CHAT_DEPARTMENT_FILTERS",
  RESET_STATE_CHAT_DEPARTMENT: "RESET_STATE_CHAT_DEPARTMENT",
  SET_ACTIVE_CHAT_DEPARTMENT: "SET_ACTIVE_CHAT_DEPARTMENT",
  SET_ISSUE_TYPE_LIST: "SET_ISSUE_TYPE_LIST",
  SET_CURRENT_PAGE_ISSUE_TYPE: "SET_CURRENT_PAGE_ISSUE_TYPE",
  SET_ISSUE_AREA: "SET_ISSUE_AREA",
  SET_ISSUE_TYPE_DETAILS: "SET_ISSUE_TYPE_DETAILS",
  SET_ISSUE_TYPE_ACTIVE_FILTERS: "SET_ISSUE_TYPE_ACTIVE_FILTERS",
  SET_SUB_ISSUE_TYPE_LIST: "SET_SUB_ISSUE_TYPE_LIST",
  SET_SUB_ISSUE_TYPE_DETAILS: "SET_SUB_ISSUE_TYPE_DETAILS",
  SET_ISSUE_TYPE_LIST_REMOTE_SEARCH: "SET_ISSUE_TYPE_LIST_REMOTE_SEARCH",
  SET_SUB_ISSUE_TYPE_ACTIVE_FILTERS: "SET_SUB_ISSUE_TYPE_ACTIVE_FILTERS",
  SET_SIDEBAR_COLLAPSED: "SET_SIDEBAR_COLLAPSED",
  SET_CURRENT_PAGE_SUB_ISSUE_TYPE: "SET_CURRENT_PAGE_SUB_ISSUE_TYPE",
  SET_CALL_DEPARTMENTS_LIST: "SET_CALL_DEPARTMENTS_LIST",
  SET_SUB_ISSUE_TYPE_LIST_REMOTE_SEARCH:
    "SET_SUB_ISSUE_TYPE_LIST_REMOTE_SEARCH",
  SET_CALL_DEPARTMENTS_ACTIVE_OBJECT: "SET_CALL_DEPARTMENTS_ACTIVE_OBJECT",
  SET_CALL_DEPARTMENTS_ACTIVE_FILTERS: "SET_CALL_DEPARTMENTS_ACTIVE_FILTERS",
  SET_CALL_DEPARTMENTS_LANGUAGE_REMOTE_SEARCH:
    "SET_CALL_DEPARTMENTS_LANGUAGE_REMOTE_SEARCH",
  SET_CALL_DEPARTMENT_CURRENT_PAGE: "SET_CALL_DEPARTMENT_CURRENT_PAGE",
  SET_FLEET_COACH_LIST: "SET_FLEET_COACH_LIST",
  SET_FLEET_COACH_CURRENT_PAGE: "SET_FLEET_COACH_CURRENT_PAGE",
  SET_FLEET_COACH_ACTIVE_OBJECT: "SET_FLEET_COACH_ACTIVE_OBJECT",
  SET_FLEET_COACH_ACTIVE_FILTERS: "SET_FLEET_COACH_ACTIVE_FILTERS",
  SET_PENDING_DEDUCTION_LIST: "SET_PENDING_DEDUCTION_LIST",
  SET_PENDING_DEDUCTION_ACTIVE_FILTERS: "SET_PENDING_DEDUCTION_ACTIVE_FILTERS",
  SET_PENDING_DEDUCTION_CURRENT_PAGE: "SET_PENDING_DEDUCTION_CURRENT_PAGE",
  SET_ORDERS_LIST_FILTERS: "SET_ORDERS_LIST_FILTERS",
  SET_ORDERS_LIST: "SET_ORDERS_LIST",
  RESET_ORDERS_LIST_AND_FILTERS: "RESET_ORDERS_LIST_AND_FILTERS",
  SET_ORDER_DETAILS: "SET_ORDER_DETAILS",
  RESET_ORDER_DETAILS: "RESET_ORDER_DETAILS",
  SET_LIFELINE_ORDER_DETAILS: "SET_LIFELINE_ORDER_DETAILS",
  SET_DRIVER_SERVICES: "SET_DRIVER_SERVICES",
  SET_EXCLUSIVE_DRIVER_SERVICES: "SET_EXCLUSIVE_DRIVER_SERVICES",
  SET_DSM_ENABLED_FEATURES: "SET_DSM_ENABLED_FEATURES",
  SET_USER_PROPERTY_LIST: "SET_USER_PROPERTY_LIST",
  SET_ACTIVE_USER_PROPERTY: "SET_ACTIVE_USER_PROPERTY",
  SET_CURRENT_PAGE_USER_PROPERTY: "SET_CURRENT_PAGE_USER_PROPERTY",
  RESET_STATE_USER_PROPERTY: "RESET_STATE_USER_PROPERTY",
  SET_USER_PROPERTY_KEYS: "SET_USER_PROPERTY_KEYS",
  SET_FLEET_COACH_DRIVER_MAPPING_LIST: "SET_FLEET_COACH_DRIVER_MAPPING_LIST",
  SET_FLEET_COACH_DRIVER_MAPPING_ACTIVE_FILTERS:
    "SET_FLEET_COACH_DRIVER_MAPPING_ACTIVE_FILTERS",
  SET_DRIVER_SHELTERS_LIST: "SET_DRIVER_SHELTERS_LIST",
  SET_ACTIVE_DRIVER_SHELTER: "SET_ACTIVE_DRIVER_SHELTER",
  SET_RIDER_OFFERS: "SET_RIDER_OFFERS",
  SET_RIDER_OFFERS_ACTIVE_FILTERS: "SET_RIDER_OFFERS_ACTIVE_FILTERS",
  RESET_STATE_RIDER_OFFERS: "RESET_STATE_RIDER_OFFERS",
  SET_PLATFORM_FEE_DETAILS: "SET_PLATFORM_FEE_DETAILS",
  SET_PLATFORM_FEE_DETAILS_ACTIVE_FILTERS:
    "SET_PLATFORM_FEE_DETAILS_ACTIVE_FILTERS",
  RESET_STATE_PLATFORM_FEE_DETAILS: "RESET_STATE_PLATFORM_FEE_DETAILS",
  SET_FLEET_COACH_APP_RELEASES_LIST: "SET_FLEET_COACH_APP_RELEASES_LIST",
  SET_FLEET_COACH_APP_RELEASES_ACTIVE_FILTERS:
    "SET_FLEET_COACH_APP_RELEASES_ACTIVE_FILTERS",
  SET_CAPACITY_CHANGE_ATTRIBUTES: "SET_CAPACITY_CHANGE_ATTRIBUTES",
  SET_CAPACITY_CHANGE_REQUESTS: "SET_CAPACITY_CHANGE_REQUESTS",
  RESET_CAPACITY_CHANGE_STORE: "RESET_CAPACITY_CHANGE_STORE",
  SET_ACTIVE_FILTERS_CAPACITY_CHANGE: "SET_ACTIVE_FILTERS_CAPACITY_CHANGE",
  SET_ENTITY_LIST_CAPACITY_CHANGE: "SET_ENTITY_LIST_CAPACITY_CHANGE",
  SET_ACTION_TYPE_LIST: "SET_ACTION_TYPE_LIST",
  SET_USER_ATTRIBUTE_LIST: "SET_USER_ATTRIBUTE_LIST",
  SET_ATTRIBUTE_LIST: "SET_ATTRIBUTE_LIST",
  SET_ATTRIBUTE_VALUE_LIST: "SET_ATTRIBUTE_VALUE_LIST",
  SET_ACTION_ATTRIBUTE_MAPPING: "SET_ACTION_ATTRIBUTE_MAPPING",
  SET_USER_ID: "SET_USER_ID",
  UPDATE_ATTRIBUTE_VALUES: "UPDATE_ATTRIBUTE_VALUES",
  SET_PRIZE_ITEM_LIST: "SET_PRIZE_ITEM_LIST",
  SET_ACTIVE_PRIZE_ITEM: "SET_ACTIVE_PRIZE_ITEM",
  SET_CURRENT_PAGE_PRIZE_ITEM: "SET_CURRENT_PAGE_PRIZE_ITEM",
  SET_ACTIVE_FILTERS_PRIZE_ITEM: "SET_ACTIVE_FILTERS_PRIZE_ITEM",
  RESET_STATE_PRIZE_ITEM: "RESET_STATE_PRIZE_ITEM",
  SET_ASSET_LIST: "SET_ASSET_LIST",
  SET_STORIES_LIST: "SET_STORIES_LIST",
  SET_ACTIVE_STORY_CAMPAIGN: "SET_ACTIVE_STORY_CAMPAIGN",
  SET_ACTIVE_FILTERS_DRIVER_STORIES: "SET_ACTIVE_FILTERS_DRIVER_STORIES",
  SET_CAMPAIGN_LIST: "SET_CAMPAIGN_LIST",
  SET_ACTIVE_CAMPAIGN: "SET_ACTIVE_CAMPAIGN",
  SET_CURRENT_PAGE_CAMPAIGN: "SET_CURRENT_PAGE_CAMPAIGN",
  SET_ACTIVE_FILTERS_CAMPAIGN: "SET_ACTIVE_FILTERS_CAMPAIGN",
  RESET_STATE_CAMPAIGN: "RESET_STATE_CAMPAIGN",
  SET_CAMPAIGN_CITIES: "SET_CAMPAIGN_CITIES",
  RESET_STATE_CAMPAIGN_CITIES: "RESET_STATE_CAMPAIGN_CITIES",
  SET_ASSET_LIST: "SET_ASSET_LIST",
  SET_ACTIVE_ASSET: "SET_ACTIVE_ASSET",
  SET_CURRENT_PAGE_ASSET: "SET_CURRENT_PAGE_ASSET",
  SET_TDS_CERTIFICATES: "SET_TDS_CERTIFICATES",
  RESET_STATE_ASSET: "RESET_STATE_ASSET",
  SET_UPLOADED_VIDEO_NAME: "SET_UPLOADED_VIDEO_NAME",
  SET_FCTASK_LIST: "SET_FCTASK_LIST",
  SET_ACTIVE_FILTERS_FCTASK: "SET_ACTIVE_FILTERS_FCTASK",
  SET_FEATURE_CONFIG_NAMESPACES: "SET_FEATURE_CONFIG_NAMESPACES",
  SET_FEATURE_CONFIG_KEYS: "SET_FEATURE_CONFIG_KEYS",
  SET_FEATURE_CONFIGS: "SET_FEATURE_CONFIGS",
  SET_ACTIVE_HIERARCHY_FILTERS_CONFIG: "SET_ACTIVE_HIERARCHY_FILTERS_CONFIG",
  RESET_STATE_FEATURE_CONFIG: "RESET_STATE_FEATURE_CONFIG",
  SET_FEATURE_CONFIG_CURRENT_NAMESPACE: "SET_FEATURE_CONFIG_CURRENT_NAMESPACE",
  SET_FEATURE_CONFIG_CURRENT_KEY: "SET_FEATURE_CONFIG_CURRENT_KEY",
  SET_FEATURE_CONFIG_PREV_PAGE: "SET_FEATURE_CONFIG_PREV_PAGE",
  SET_FEATURE_CONFIG_NEXT_PAGE: "SET_FEATURE_CONFIG_NEXT_PAGE",
  SET_FEATURE_CONFIG_USER_DATA: "SET_FEATURE_CONFIG_USER_DATA",
  SET_RESTRICTED_PAYOUT_DRIVERS: "SET_RESTRICTED_PAYOUT_DRIVERS",
  SET_COMMUNICATION_HUB_OPTIONS: "SET_COMMUNICATION_HUB_OPTIONS",
  SET_COMMUNICATION_HUB_OPTIONS_LOADING:
    "SET_COMMUNICATION_HUB_OPTIONS_LOADING",
  SET_DLRC_DETAILS: "SET_DLRC_DETAILS",
  SET_EV_DETAILS: "SET_EV_DETAILS",
  SET_DLRC_ADDITIONAL_DATA: "SET_DLRC_ADDITIONAL_DATA",
  RESET_STATE_DLRC: "RESET_STATE_DLRC",
  SET_DLRC_CURRENT_FEID: "SET_DLRC_CURRENT_FEID",
  SET_DRIVER_BANNER_LIST: "SET_DRIVER_BANNER_LIST",
  SET_ACTIVE_FILTERS_DRIVER_BANNER: "SET_ACTIVE_FILTERS_DRIVER_BANNER",
  SET_BANNER_DETAILS: "SET_BANNER_DETAILS",
  SET_TARGET_AUDIENCE: "SET_TARGET_AUDIENCE",
  SET_TARGETABLE_BUSINESS: "SET_TARGETABLE_BUSINESS",
  SET_DISPUTES_LIST_FILTERS: "SET_DISPUTES_LIST_FILTERS",
  SET_DISPUTES_LIST: "SET_DISPUTES_LIST",
  RESET_DISPUTES_LIST_AND_FILTERS: "RESET_DISPUTES_LIST_AND_FILTERS",
  SET_DISPUTES_DETAILS: "SET_DISPUTES_DETAILS",
  RESET_DISPUTES_DETAILS: "RESET_DISPUTES_DETAILS",
};

export default ActionTypes;
